import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import { prepareFilters } from '../../../components/Filters/request';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      ...item,
      key: item.id,
      select: { id: item.id, value: false },
      creator: item.user,
      status: item.status,
      date: { start_at: item.starts_at, ends_at: item.starts_at },
      bonus_gift: { status: item.status, earned_amount: item.earned_amount, max_bonus_amount: item.max_bonus_amount },
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getReimbursements({ payload: { signal, filters, searchQ, curr_page } }) {
  try {

    const { sort, status } = prepareFilters(filters);

    const { data } = yield call(fetch, {
      api: api.reimbursements.list,
      params: {
        page: curr_page,
        ordering: sort[0],
        ...(status ? { status } : {}),
        ...(searchQ && { q: searchQ })
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getReimbursementsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getReimbursementsFailed,
      endpoint: api.reimbursements.list.url
    });
  }
}

export const getReimbursementsSaga = takeEvery(types.GET_REIMBURSEMENTS_REQUEST, getReimbursements);